import { createFileRoute } from '@tanstack/react-router'
import { Navbar } from '@/components/landing/navbar'
import { Footer } from '@/components/landing/footer'
import { SupportForm } from '@/components/landing/support-form'
import type { MobileDeviceInfo } from '@/lib/support'

type SupportSearch = MobileDeviceInfo

// The router auto-parses search values, so a param like `sysVersion=17.4`
// arrives as the number 17.4. Coerce any string/number to a trimmed string.
const asString = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value || undefined
  if (typeof value === 'number' && Number.isFinite(value)) return String(value)
  return undefined
}

export const Route = createFileRoute('/support')({
  // Device info is passed by the mobile app when it opens this page in a
  // WebView (e.g. /support?deviceType=iOS&appVersion=1.2.0&deviceId=...).
  validateSearch: (search: Record<string, unknown>): SupportSearch => ({
    deviceType: asString(search.deviceType),
    sysVersion: asString(search.sysVersion),
    appVersion: asString(search.appVersion),
    deviceId: asString(search.deviceId),
    userCountry: asString(search.userCountry),
  }),
  component: SupportPage,
})

function SupportPage() {
  const deviceInfo = Route.useSearch()

  return (
    <div
      style={{
        background: '#F8FAFF',
        minHeight: '100vh',
        fontFamily: '"Plus Jakarta Sans", "DM Sans", sans-serif',
        color: '#111827',
        overflowX: 'hidden',
      }}
    >
      <Navbar />

      <main
        style={{
          maxWidth: '760px',
          margin: '0 auto',
          padding: '140px 24px 96px',
        }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <p
            style={{
              fontSize: '13px',
              color: '#3B82F6',
              marginBottom: '12px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontWeight: '600',
            }}
          >
            Support
          </p>
          <h1
            style={{
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: '800',
              color: '#111827',
              margin: '0 0 14px',
              letterSpacing: '-1px',
            }}
          >
            How can we{' '}
            <span
              style={{
                background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              help?
            </span>
          </h1>
          <p
            style={{
              fontSize: '16px',
              color: '#6B7280',
              maxWidth: '480px',
              margin: '0 auto',
              lineHeight: '1.7',
            }}
          >
            Having trouble receiving a code or managing your numbers? Send us a
            message and the GetCode team will get back to you as soon as
            possible.
          </p>
        </div>

        <SupportForm deviceInfo={deviceInfo} />

        <p
          style={{
            textAlign: 'center',
            fontSize: '14px',
            color: '#9CA3AF',
            marginTop: '28px',
          }}
        >
          Prefer email? Reach us at{' '}
          <a href="mailto:support@getcode.app" style={{ color: '#3B82F6' }}>
            support@getcode.app
          </a>
        </p>
      </main>

      <Footer />
    </div>
  )
}
